<template>
  <div class="col-lg-9 c-content-main">
    <div class="tile">
      <h3 class="tile-title is-line">{{$t('userGroups')}}</h3>
      <div class="tile-body">
    <div class="c-config-content">
        <div v-if="firstLoading">
            <skeleton-loading>
                <row>
                    <square-skeleton :boxProperties="{bottom: '10px', height: '30px'}"></square-skeleton>
                </row>
                <row>
                    <square-skeleton :boxProperties="{bottom: '10px', height: '200px'}"></square-skeleton>
                </row>
            </skeleton-loading>
        </div>
        <div v-else>
            <div class="c-template-table table-responsive c-role-table">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th>{{$t('group')}}</th>
                        <th>{{$t('desc')}}</th>
                        <th class="text-center">{{$t('ext')}}</th>
                        <th class="th-80 text-right">
                            <span @click="create" class="btn-add" v-if="$store.state.user.permissions.includes('userManageAll')">
                              <i class="icon16-plus-circle-gadient"></i></span>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><span class="c-signal">{{$t('groupDefault')}}</span></td>
                        <td>{{$t('groupDefault')}}</td>
                        <td class="text-center">0000</td>
                        <td class="text-right"></td>
                    </tr>
                    <tr v-for="item in items" :key="item._id">
                        <td><span :class="[item.active ? 'c-signal is-success' : 'c-signal']">{{item.name}}</span>
                        </td>
                        <td>{{item.desc}}</td>
                        <td class="text-center">{{item.ext}}</td>
                        <td class="text-right">
                            <button @click="del(item._id)" class="mr-1 btn btn-outline-gray btn-sm is-border-1" :disabled="delLoading" 
                            type="button" v-if="$store.state.user.permissions.includes('userManageAll')">
                                <b-spinner v-if="delLoading" small></b-spinner>
                                <i v-else class="icon12-delete-primary"></i>
                            </button>
                            <button @click="update(item._id)" class="btn btn-outline-gray btn-sm is-border-1" :disabled="updateLoading"
                                    type="button" v-if="$store.state.user.permissions.includes('userManageAll')">
                                <b-spinner v-if="updateLoading" small></b-spinner>
                                <i v-if="!updateLoading" class="icon12-edit-primary"></i>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <b-modal v-model="showForm" :title="formTitle + $t('groupFormTitle')" @ok="save" no-close-on-backdrop
                     no-enforce-focus>
                <form-input :label="$t('name')" :model="formModel" attribute="name" :errors="formErrors"
                            :placeholder="$t('groupNamePlaceholder')"></form-input>
                <form-input :label="$t('ext')" :model="formModel" attribute="ext" :errors="formErrors"
                            :placeholder="$t('groupExtPlaceholder')"></form-input>
                <form-textarea :label="$t('desc')" :model="formModel" attribute="desc" :errors="formErrors"
                               :placeholder="$t('groupDescPlaceholder')"></form-textarea>
                <recording-select :label="$t('moh')" :model="formModel" attribute="moh"
                                  :errors="formErrors"></recording-select>
                <target-select :label="$t('execOnFailureGroup')" :model="formModel" :errors="formErrors"
                               attribute="execOnFailure"></target-select>
                <form-checkbox :chk-label="$t('activated')" :model="formModel" attribute="active"
                               :errors="formErrors"></form-checkbox>
                <template v-slot:modal-footer>
                    <b-button variant="secondary" class="float-right" @click="showForm = false">{{$t('cancel')}}
                    </b-button>
                    <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="save">
                        <b-spinner v-if="saveLoading" small></b-spinner>
                        {{$t('save')}}
                    </b-button>
                </template>
            </b-modal>
        </div>
    </div>
      </div>
    </div>
  </div>
</template>

<script>
    import list from '../../../mixins/List';
    import crud from '../../../mixins/CRUD';
    import RecordingSelect from "../../../components/RecordingSelect";
    import TargetSelect from "@/components/TargetSelect";

    export default {
        mixins: [list, crud],
        components: {TargetSelect, RecordingSelect},
        data: function () {
            return {
                service: "/user-group",
                autoLoad: true,
                model: {},
                defaultFormModel: {
                    active: true
                }
            };

        }
    }
</script>